import { useEffect, useRef, useState } from "react";
import "../../css/Search/Search.css";
import { searchRequest } from "./SearchRequest";
import { useNavigate } from "react-router-dom";
import SearchResults from "./SearchResults";
import RecentSearch from "./RecentSearch";
import Explorer from "./Explorer/Explorer";
import { useTranslation } from "react-i18next";

function Search({ theme }) {
  const searchInputRef = useRef();

  const [searchData, setSearchData] = useState([]);
  const [searchStatus, setSearchStatus] = useState("explorer");

  const {t}= useTranslation();

  useEffect(() => {
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, []);

  return (
    <div className="mainDiv"> 
      <div className={`headerDiv noPadding ${theme}`}>
        <input
          className="searchInput"
          placeholder={t("Search")}
          ref={searchInputRef}
          onChange={(e) => {
            if (e.target.value.length > 0) {
              setSearchStatus("results");
              searchRequest(e.target.value, setSearchData);
            } else {
              setSearchStatus("recent");
            }
          }}
          onClick={() => {
            setSearchStatus("recent");
          }}
        ></input>

        {(searchStatus == "recent" || searchStatus == "results") && (
          <button className={`iconButton ${theme}`} onClick={() => {
            setSearchStatus('explorer')
          }}>
            <img src="/icons/close.png"></img>
          </button>
        )}
      </div>

      <div className="contentDiv">
        {searchStatus === "recent" && <RecentSearch></RecentSearch>}
        {searchStatus === "results" && (
          <SearchResults searchData={searchData}></SearchResults>
        )}
        {searchStatus === "explorer" && <Explorer></Explorer>}
      </div>
    </div>
  );
}

export default Search;
